"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsRender = void 0;
var react_1 = require("react");
var use_analytics_1 = require("../lib/use-analytics");
function AnalyticsRender(_a) {
    var name = _a.name, children = _a.children, properties = _a.properties;
    var dispatch = (0, use_analytics_1.useAnalytics)().dispatch;
    (0, react_1.useEffect)(function () {
        dispatch({ type: 'render', name: name, properties: properties });
    }, [name]);
    return children;
}
exports.AnalyticsRender = AnalyticsRender;
